module.exports = __webpack_public_path__ + "static/media/navbar_logo.78a01d44.png";